import React, { createRef } from "react";
import Context from "../../../context/Context";
import * as officePlanUtil from "../../base/officePlanUtil";

export default class LegendItems extends React.Component {

  _coreNode;
  _coreWidget;
  nodeRef = createRef();

  constructor(props) {
    super(props);
    this.setCoreNode = this.setCoreNode.bind(this);
  }

  componentDidMount() {
    this._initWidget();
  }

  _initWidget() {
    const context = Context.getInstance();
    const lib = context.lib;
    const featureLayer = officePlanUtil.getUnitsSource().layer2D;
    const view = (context.views && context.views.activeView);
    if (this._coreNode) {
      this._coreWidget = new lib.esri.Legend({
        container: this._coreNode,
        view: view,
        layerInfos: [{
          layer: featureLayer
        }]
      })
    }
  }

  render() {
    return <div ref={this.setCoreNode}></div>;
  }

  setCoreNode(node) {
    this._coreNode = node;
  }

}